/* eslint-disable no-unused-vars */
import { HeadingFieldSize } from '@/constants/form/HeadingFieldSize'
import { FormField, FormFieldType } from './formField'

/**
 * Creates an instance of HeadingField.
 * @typedef {Object} HeadingFieldType
 * @property {HeadingFieldSize} size
 *
 * @typedef {FormFieldType & HeadingFieldType} HeadingFieldExtendType
 */

/**
 * Represents a heading field on a form.
 * @class
 */
export class HeadingField extends FormField {
  /**
   * Create a new HeadingField.
   * @param {HeadingFieldExtendType} params
   */
  constructor(params) {
    super(params)
    this.size = params.size
  }
}
